var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{on:{"before-enter":_vm.before_enter,"enter":_vm.enter,"after-enter":_vm.after_enter,"before-leave":_vm.before_leave,"leave":_vm.leave,"after-leave":_vm.after_leave}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }